import type { Routes } from '@angular/router';
import { secureRoute } from './core/utils/transformers';
import { EwusKolceViewComponent } from './features/nfz/pages/ewus-kolce-view/ewus-kolce-view';
import { P1ViewComponent } from './features/nfz/pages/p1-view/p1-view';
import { SettlementsViewComponent } from './features/nfz/pages/settlements-view/settlements-view';

export const nhfRoutes: Routes = [
  secureRoute({
    path: 'nfz/ewus-kolce',
    component: EwusKolceViewComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'ewus-kolce',
          isCurrent: true,
          url: '/nfz/ewus-kolce',
        },
      ],
    },
  }),
  secureRoute({
    path: 'nfz/p1',
    component: P1ViewComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'p1',
          isCurrent: true,
          url: '/nfz/p1',
        },
      ],
    },
  }),
  secureRoute({
    path: 'nfz/settlements',
    component: SettlementsViewComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'settlements',
          isCurrent: true,
          url: '/nfz/settlements',
        },
      ],
    },
  }),
];
